import isMobile from "@src/utils/isMobile";
import { useStartExperimentWhenInAudience } from "@src/utils/experiment";
import { ExternalSwitches } from "@src/utils/experiments/constants";

export const useTeacherSignupMobileRedesign = () => {
  const isMobileView = isMobile().phone;
  const variant = useStartExperimentWhenInAudience(ExternalSwitches.WEB_EXTERNAL_TEACHER_MWEB_SIGNUP, {
    isInAudience: isMobileView,
  });

  return variant === "test";
};
